import { validateContentReference } from '@gitbook/app-content-refs';
import { Schema } from '@gitbook/slate';

import { BLOCK_IF, BLOCK_OPENAPI_WEBHOOK } from '../types';

const validateRef = validateContentReference(['openapi']);

/*
 * Schema to validate OpenAPI Webhook blocks.
 */
export const schema = Schema.create({
    blocks: {
        [BLOCK_OPENAPI_WEBHOOK]: {
            parent: { objects: ['document', 'block'], types: [undefined, BLOCK_IF] },
            isVoid: true,
            data: {
                name: (data: unknown) => typeof data === 'string',
                method: (data: unknown) => typeof data === 'string',
                ref: (data: unknown) => validateRef(data),
                headless: (data: unknown) => data === undefined || typeof data === 'boolean',
            },
        },
    },
});
